/* =============================================
   PRODUCT CARD GALLERY — Chevron Navigation JS
   Ajouter dans Assets comme pcg-chevrons.js
   puis dans theme.liquid avant </body> :
   <script src="{{ 'pcg-chevrons.js' | asset_url }}" defer></script>
   ============================================= */

(function () {
  if (window.__pcgChevronInit) return;
  window.__pcgChevronInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pcg-prev], [data-pcg-next]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var wrapper = btn.closest('[data-pcg-wrapper]');
    if (!wrapper) return;

    var items = wrapper.querySelectorAll('[data-pcg-item]');
    var dots = wrapper.querySelectorAll('.pcg-indicator');
    if (items.length < 2) return;

    var currentIndex = -1;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].classList.contains('pcg-item--hidden')) {
        currentIndex = i;
        break;
      }
    }
    if (currentIndex === -1) currentIndex = 0;

    var direction = btn.hasAttribute('data-pcg-next') ? 1 : -1;
    var nextIndex = (currentIndex + direction + items.length) % items.length;

    /* Switch slides */
    items[currentIndex].classList.add('pcg-item--hidden');
    items[currentIndex].classList.remove('is-active');

    items[nextIndex].classList.remove('pcg-item--hidden');
    items[nextIndex].classList.add('is-active');

    /* Switch dots */
    if (dots.length > 0) {
      if (dots[currentIndex]) dots[currentIndex].classList.remove('pcg-indicator--active');
      if (dots[nextIndex]) dots[nextIndex].classList.add('pcg-indicator--active');
    }
  });
})();
